import $ from 'jquery';

// SearchRoomManager.ts
export class SearchRoomManager {
    private totalRooms: number = 1;
    private maxRooms: number;

    constructor(maxRooms: number) {
        this.maxRooms = maxRooms;
    }

    public init(): void {
        this.initChildAges();
        this.initCounters();
        this.initRoomButtons();
    }

    private initChildAges(): void {
        this.validateChildAges();

        $(document).on("change", ".child-age", (e) => {
            const target = e.currentTarget as HTMLElement;
            const updateField = $(target).data("update-field");
            $(`#${updateField}`).val($(target).val() ?? "");
            this.updateRoomInfoString();
            this.validateChildAges();
        });
    }

    public validateChildAges(): boolean {
        let success = true;

        $("#btnSubmitSearch").addClass("ignore-popover-close");

        $(".child-age").each(function () {
            const $this = $(this);
            const isVisible = $this.is(":visible");
            const value = $this.val();

            if (isVisible && value === "-1") {
                $this.addClass("input-error");
                $this.siblings(".error-message").removeClass("hidden");
                $this.siblings(".error-message").css("display", "block");
                success = false;
            } else {
                $this.removeClass("input-error");
                $this.siblings(".error-message").addClass("hidden");
                $this.siblings(".error-message").css("display", "none");
            }
        });

        if (success) {
            $("#btnSubmitSearch").removeClass("ignore-popover-close");
        }

        return success;
    }

    private initRoomButtons(): void {
        // --- Ensure totalRooms reflects actual active rooms on page load ---
        this.totalRooms = $(".search-room").filter(function () {
            return !$(this).hasClass("hidden");
        }).length;

        // --- Fix on page load ---
        this.updateRoomRemoveButtons();

        // --- Add room ---
        $(document).on("click", ".btn-add-room", (e) => {
            e.preventDefault();

            const room = $(`.search-room[data-room-number='${this.totalRooms + 1}']`);
            room.removeClass("hidden");
            room.find(".isRoomActive").val("True");

            this.updateRoomRemoveButtons();
            this.updateGuestsDisplay();
        });

        // --- Remove room ---
        $(document).on("click", ".btn-remove-room", (e) => {
            e.preventDefault();

            const thisRoom = $(`.search-room[data-room-number='${this.totalRooms}']`);
            thisRoom.addClass("hidden");
            thisRoom.find(".isRoomActive").val("False");

            this.updateRoomRemoveButtons();
            this.updateGuestsDisplay();
        });
    }

    private updateRoomRemoveButtons(): void {
        // Hide all remove buttons first
        $(".btn-remove-room").addClass("hidden");

        // Find all active (visible) rooms
        const activeRooms = $(".search-room").filter(function () {
            return !$(this).hasClass("hidden");
        });

        // Only show remove button for the last visible room (but not if it's the only one)
        if (activeRooms.length > 1) {
            const lastRoom = activeRooms.last();
            lastRoom.find(".btn-remove-room").removeClass("hidden");
        }
    }

    private updateGuestsDisplay(): void {
        this.totalRooms = 0;
        let totalGuests = 0;

        // Count visible rooms
        this.totalRooms = $(".search-room").filter((_, el) => !$(el).hasClass("hidden")).length;

        // Show/hide add room link
        if (this.totalRooms === this.maxRooms) {
            $(".btn-add-room").addClass("hidden");
            $(".popover-rooms-need-more-msg").removeClass("hidden");
        } else {
            $(".btn-add-room").removeClass("hidden");
            $(".popover-rooms-need-more-msg").addClass("hidden");
        }

        // Count adults
        $(".adults-counter").each(function () {
            if (!$(this).closest(".search-room").hasClass("hidden")) {
                totalGuests += parseInt($(this).val() as string, 10);
            }
        });

        // Count children + toggle child age fields
        $(".children-counter").each(function () {
            if (!$(this).closest(".search-room").hasClass("hidden")) {
                const numberOfChildren = parseInt($(this).val() as string, 10);
                totalGuests += numberOfChildren;

                let i = 1;
                $(this)
                    .closest(".search-room")
                    .find(".kids-age")
                    .each(function () {
                        if (i <= numberOfChildren) {
                            $(this).removeClass("hidden");
                        } else {
                            $(this).addClass("hidden");
                        }
                        i++;
                    });
            }
        });

        const roomLabel = this.totalRooms === 1 ? window._screenMessages.Room : window._screenMessages.Rooms;
        const guestLabel = totalGuests === 1 ? window._screenMessages.Guest : window._screenMessages.Guests;
        const guestDisplay = `${totalGuests} ${guestLabel}, ${this.totalRooms} ${roomLabel}`;

        $(".guests-display").html(guestDisplay);
        $("#SearchBarForm_UpdatedRooms").val(this.totalRooms);

        this.updateRoomInfoString();
    }

    private updateRoomInfoString(): void {
        let roomInfoString = "";

        $(".search-room").each(function () {
            if (!$(this).hasClass("hidden")) {
                const numberAdults = $(this).find(".adults-counter").val();
                const numberChildren = $(this).find(".children-counter").val();
                roomInfoString += `${numberAdults},${numberChildren}`;

                if (parseInt(numberChildren as string, 10) > 0) {
                    let childAges = "";
                    $(this)
                        .find(".kids-age")
                        .each(function () {
                            if (!$(this).hasClass("hidden")) {
                                const childAge = $(this).children(".child-age").first().val();
                                childAges += `${childAge}-`;
                            }
                        });
                    if (childAges.endsWith("-")) {
                        childAges = childAges.slice(0, -1);
                    }
                    roomInfoString += `,${childAges}`;
                }

                // Room separator
                roomInfoString += "R";
            }
        });

        if (roomInfoString.endsWith("R")) {
            roomInfoString = roomInfoString.slice(0, -1);
        }

        $("#SearchBarForm_RoomInfoString").val(roomInfoString);
    }

    private initCounters(): void {
        $(document).on("click", ".guests-counter", (e) => {
            e.preventDefault();
            setTimeout(() => {
                this.updateGuestsDisplay();
            }, 30);
        });
    }
}
